var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-content',[_c('div',{staticClass:"shadow-sm rounded p-4"},[_c('settlement-form',{attrs:{"form_data":_vm.form_data,"form_meta_data":_vm.form_meta_data,"on_submit":_vm.settlement}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }